<template>
  <div class="col-lg-10 col-lg-offset-1 payment-container">
    <v-layout row wrap>
      <v-flex lg6 md6 sm12 xs12>
        <v-container>
          <v-card flat class="futuristic-card">
            <div class="card-header">
              <h4 class="earth-color">Terms and Conditions</h4>
              <div class="title-decoration"></div>
            </div>
            <v-container>
              <label class="futuristic-label">Content</label>
              <vue-editor v-model="page.description" class="futuristic-editor"></vue-editor>
              <v-btn
                :depressed="true"
                block
                color="primary"
                @click="postTermsAndConditions()"
                class="futuristic-btn"
              >Publish</v-btn>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex lg6 md6 sm12 xs12>
        <v-container>
          <v-card flat class="futuristic-card">
            <div class="card-header">
              <h4 class="earth-color">Preview</h4>
              <div class="title-decoration"></div>
            </div>
            <v-container class="preview-content">
              <span v-html="page.description"></span>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
      {{updatePage}}
    </v-layout>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
export default {
  name: 'terms-and-conditions',
  components: {
    VueEditor
  },
  data () {
    return {
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      page: {
        name: 'Terms and Conditions',
        page_type: 't&c',
        description: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  created () {
    this.$store.dispatch('get_page', 't&c')
  },
  methods: {
    postTermsAndConditions: function () {
      this.$store.dispatch('post_page', this.page)
    }
  }
}
</script>

<style scoped>
/* Futuristic Container */
.payment-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

/* Card Header */
.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

/* Futuristic Label */
.futuristic-label {
  color: #587e27;
  font-weight: 500;
  font-size: 1rem;
  margin-bottom: 8px;
  display: block;
}

/* Futuristic Editor */
.futuristic-editor >>> .ql-toolbar {
  background: #f5f7fa;
  border-radius: 8px 8px 0 0;
  border: 1px solid #e8eaf6;
}

.futuristic-editor >>> .ql-container {
  background: #f5f7fa;
  border-radius: 0 0 8px 8px;
  border: 1px solid #e8eaf6;
  border-top: none;
  transition: all 0.2s ease;
}

.futuristic-editor:hover >>> .ql-container {
  background: #e8eaf6;
}

/* Futuristic Button */
.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  color: white !important;
  background: linear-gradient(45deg, #587e27, #4caf50) !important;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Preview Content */
.preview-content {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
  min-height: 200px;
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .payment-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }
}

@media (max-width: 600px) {
  .payment-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1rem;
  }
}
</style>
